export default __webpack_public_path__ + "e1db39d24e600ba3e3c031c9e415a164.jpg";